/**
 * Function原型扩展
 */
Object.assign(Function.prototype, {
	delay: Object.assign(function (duration, ...args) {
		clearTimeout(this.delay.timer);
		this.delay.timer = setTimeout(() => this.apply(this, args), duration);
	}, { timer: -1 })
});